'use client';

import { ComponentPropsWithoutRef, useContext } from 'react';
import { cn } from '@/shared/lib/cn';
import { Select } from '@/shared/ui/select';
import '@/shared/ui/select/select.scss';
import { MultiSelectContext } from './multi-select-context';

type Props = ComponentPropsWithoutRef<typeof Select.Item>;
export const MultiSelectItem = ({ className, value, ...props }: Props) => {
    const { values } = useContext(MultiSelectContext);

    return (
        <Select.Item
            className={cn(values.includes(value) && 'select__item--selected', className)}
            value={value}
            {...props}
        />
    );
};
